// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1ZeV0","noInteraction":"EventWrapper_noInteraction__a2WLX"};